export default __webpack_public_path__ + "static/media/nokia-phone.019e192e.png";